import React from "react";
import { Link } from "react-router-dom";
import HeroVideo from "../../components/hero-video/HeroVideo";
import StatsBar from "../../components/stats-bar/StatsBar";
import AboutSection from "../../components/about-section/AboutSection";
import AboutCard from "../../components/about-card/AboutCard";
import FeatureCards from "../../components/feature-cards/FeatureCards";
import VisionMission from "../../components/vision-mission/VisionMission";
import QuoteHero from "../../components/quote-hero/QuoteHero";
import "./Home.css";
import { CareersPreview } from "../../components/careers-preview/CareersPreview";

// const SERVICES = [
//   { icon: "🌐", title: "Web Development",     desc: "Scalable React, Next.js & Node.js web applications.",        tag: "React · Node · Next.js" },
//   { icon: "📱", title: "Mobile App Dev",       desc: "Cross-platform apps for iOS & Android.",                    tag: "React Native · Flutter" },
//   { icon: "🤖", title: "AI & Machine Learning",desc: "Intelligent systems that automate and predict.",            tag: "Python · TensorFlow" },
//   { icon: "☁️", title: "Cloud & DevOps",       desc: "AWS, Docker & Kubernetes cloud infrastructure.",           tag: "AWS · Docker · K8s" },
//   { icon: "🔒", title: "Cyber Security",        desc: "VAPT, ethical hacking & security architecture.",           tag: "VAPT · Penetration" },
//   { icon: "🎨", title: "UI/UX Design",          desc: "Figma-first design systems that convert and delight.",    tag: "Figma · Adobe XD" },
// ];
const SERVICES = [
  {
    icon: "🌐",
    title: "Web Development",
    desc: "High-performance websites that attract customers and grow your business online.",
    tag: "React · Node · Next.js"
  },
  {
    icon: "📱",
    title: "Mobile App Dev",
    desc: "User-friendly mobile apps that engage customers and boost your brand presence.",
    tag: "React Native · Flutter"
  },
  {
    icon: "🤖",
    title: "AI & Machine Learning",
    desc: "Smart AI solutions that automate tasks, improve decisions, and save time.",
    tag: "Python · TensorFlow"
  },
  {
    icon: "📊",
    title: "CRM Solutions",
    desc: "CRM systems to streamline customer communication, sales tracking, and workflows.",
    tag: "Automation · Sales · Workflow"
  },
  {
    icon: "🏢",
    title: "ERP Systems",
    desc: "ERP applications to manage complete business operations in one integrated platform.",
    tag: "Finance · HR · Operations"
  }
  ,
  {
    icon: "🧩",
    title: "Custom Product Development",
    desc: "End-to-end product development from idea to scalable SaaS solutions.",
    tag: "Startup · SaaS · MVP"
  }
];

const Home: React.FC = () => {
  return (
    <div className="home">

      {/* 1. VIDEO HERO — first thing visible */}
      <HeroVideo />

      {/* 2. STATS */}
      <StatsBar />

      {/* 3. SERVICES OVERVIEW */}
      <section className="home-services">
        <div className="container">
          <div className="home-services__header">
            <span className="section-label">What We Do</span>
            <h2 className="section-title">Our Technology Services</h2>
            <p className="section-subtitle">
              “Ajera Infotech builds innovative software and AI solutions to solve real-world problems.”
            </p>
          </div>
          <div className="home-services__grid">
            {SERVICES.map((s, i) => (
              <div key={i} className="svc-card" style={{ animationDelay: `${i * 0.07}s` }}>
                <div className="svc-card__icon">{s.icon}</div>
                <h3 className="svc-card__title">{s.title}</h3>
                <p className="svc-card__desc">{s.desc}</p>
                {/* <span className="svc-card__tag">{s.tag}</span> */}
                <div className="svc-card__bar" />
              </div>
            ))}
          </div>
          <div className="home-services__cta">
            <Link to="/what-we-do" className="btn-outline">
              View All Services
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="15" height="15">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div>
      </section>

      {/* 6. FEATURE CARDS */}
      <FeatureCards />

      {/* 4. ABOUT SECTION */}
      <AboutSection />

        {/* 7. CAREER SHORTCUT */}
      <CareersPreview/>

      {/* 8. QUOTE */}
      <QuoteHero />

      {/* 9. CTA BANNER */}
      <section className="home-cta">
        <div className="container">
          <div className="home-cta__box">
            <div className="home-cta__glow" />
            <span className="section-label">Ready to Start?</span>
            <h2 className="home-cta__title">Let's Build Something Amazing</h2>
            <p className="home-cta__sub">
              Tell us about your project and we'll respond within 24 hours.
            </p>
            <div className="home-cta__actions">
              <Link to="/contact" className="btn-primary">
                Start Your Project
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="16" height="16">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </Link>
              <a
                href="https://wa.me/919751772429"
                target="_blank"
                rel="noopener noreferrer"
                className="home-cta__wa"
              >
                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                Chat on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
